<template>
	<el-container class="im-service-index">
		<!--  用户列表 -->
		<div class="im-service-index__user">
			<ul class="tabs">
				<li @click="tabClick(item)" :class="{'active':item.key == active_tab}" v-for="(item,index) in tabs"
					:key="index">{{item.text}}</li>
			</ul>
			<div class="user-list">
				<dialogueList v-if="active_tab == 'dialogue'"/>
				<endedList v-else @toSwitchUserTab="toSwitchUserTab"/>
			</div>
		</div>
		<!-- 会话详情面板 -->
		<div class="im-service-index__container">
			<dialoguePanel v-if="active_tab == 'dialogue'"/>
			<endedPanel v-else :source="active_session"/>
		</div>
	</el-container>
</template>

<script>
	import {dialogueList,endedList} from './user/index.js';
	import {dialoguePanel,endedPanel} from './panels/index.js';
	import { mapGetters } from "vuex";
	const title = document.title;
	
	export default {
		components:{
			dialogueList,
			endedList,
			dialoguePanel,
			endedPanel
		},
		computed:{
			...mapGetters(['unreadChatNum'])
		},
		watch:{
			'unreadChatNum':{
				handler(value){
					clearInterval(this.interval)
					if (value > 0) {
						this.interval = setInterval(() => {
						  document.title = document.title == title ? `【新消息】${title}` : title
						}, 2000)
					} else {
						document.title = title
					}
				},
				immediate:true
			}
		},
		data() {
			return {
				tabs: [{
						text: "对话中",
						key: "dialogue"
					},
					{
						text: "已结束",
						key: "ended"
					}
				],
				active_tab:'dialogue',
				active_session:{},
				interval:null
			}
		},
		methods:{
			tabClick(item){
				this.active_tab = item.key;
				this.active_session = {};
				this.$store.commit('imChatService/SET_INDEX_NAME','');
				this.$store.commit('imChatService/SET_INDEX_INFOS',{})
			},
			toSwitchUserTab(data){
				this.active_session = data;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.im-service-index {
		border: 1px solid #d8d8d8;
		border-radius: 4px;
		height: calc(100vh - 94px);
		overflow: hidden;
		
		&__user {
			width: 294px;
			background-color: #fff;
			border-right: 1px solid #d8d8d8;
			height: 100%;
			padding: 0;
			margin: 0;
			overflow: hidden;

			.tabs {
				width: 100%;
				height: 55px;
				border-bottom: 1px solid #D8D8D8;
				display: flex;
				justify-content: space-between;
				align-items: center;
				cursor: pointer;

				li {
					list-style: none;
					width: 50%;
					height: 100%;
					text-align: center;
					line-height: 55px;
					text-align: center;
					font-size: 14px;
					color: #3C4353;
					font-weight: 500;

					&.active {
						color: #0F81FB;
						border-bottom: 2px solid #0F81FB;
					}
				}
			}
			.user-list {
				width: 100%;
				height: calc(100% - 55px);
				overflow: hidden;
				box-sizing: border-box;
			}
		}
		
		&__container {
			width: calc(100% - 294px);
			height: 100%;
			overflow: hidden;
		}
	}
</style>
